// extracted by mini-css-extract-plugin
export default {"image":"FW-z","loaded":"GW-z"};